module.exports = __webpack_public_path__ + "img/cert12.b7ce55b6.png";